import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Params } from '@angular/router';

@Component({
  selector: 'app-plan-item',
  templateUrl: './plan-item.component.html',
  styleUrls: ['./plan-item.component.scss'],
})
export class PlanItemComponent {

  @Input() plan: Params = {};
  @Input() options: Params = [];
  @Input() selected = false;
  @Output() openBenefitsModalBtnClicked = new EventEmitter();
  @Output() openDownloadsModalBtnClicked = new EventEmitter();
  @Output() openBenefitsSelectionModalBtnClicked = new EventEmitter();
  @Output() planSelected = new EventEmitter();

  constructor() {
  }

  showBenefitsModal() {
    this.openBenefitsModalBtnClicked.emit([...this.plan.benefits.col1, ...this.plan.benefits.col2]);
  }

  showDownloadsModal() {
    this.openDownloadsModalBtnClicked.emit(this.plan.assets);
  }

  emitSelectedPlanEvent(): void {
    if (Array.isArray(this.plan.additionalBenefits) && this.plan.additionalBenefits.length) {
      this.openBenefitsSelectionModalBtnClicked.emit(this.plan);
      return;
    }
    this.planSelected.emit({ id: this.plan.id, benefitOption: '000' });
  }

}
